import { APP_STATUS, FAILURE_ERROR_SCREENS, FAILURE_REJECT_SCREENS, PROGRESS } from 'config/config';
import withProgressBar from 'hoc/withProgressBar';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { ILoadingState } from 'types/ILoadingState';
import { IRecoveryPayment } from 'types/IRecoveryPayment';

import { RecoveryPaymentButton } from '../../../recoveryPaymentButton/RecoveryPaymentButton';
import Spinner from '../../../spinner/Spinner';

import {
  FailureScreenBackToShopButton,
  FailureScreenButtonWrapper,
  FailureScreenContainer,
  FailureScreenIcon,
  FailureScreenMessage1,
  FailureScreenMessage2,
  FailureScreenTitle,
  FailureScreenWrapper,
} from './FailureScreen.styles';

class FailureScreen extends PureComponent<IRecoveryPayment & Partial<IContext> & Partial<ITextContext>, ILoadingState> {
  innerRef = React.createRef<HTMLDivElement>();

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
  }

  componentDidMount() {
    const { setPaymentStatusText } = this.props;
    if (setPaymentStatusText) {
      setPaymentStatusText('finalScreen.message6', 'finalScreen.message7');
    }
  }

  setLoading = () => {
    this.setState({ isLoading: true });
  };

  handleError = (error: Error) => {
    this.setState(() => {
      throw error;
    });
  };

  handleClick = () => {
    this.redirectToUrl();
  };

  private getFailureScreens() {
    const { status } = this.props;
    return status === APP_STATUS.FAILURE ? FAILURE_REJECT_SCREENS : FAILURE_ERROR_SCREENS;
  }

  redirectToUrl = () => {
    const { redirectToShop } = this.props;
    window.location.assign(redirectToShop);
  };

  render() {
    const { title, icon, message1, message2, buttonText } = this.getFailureScreens();
    const { isLoading } = this.state;
    const { recoveryEnabled, paymentId } = this.props;
    const containerHeight = this.innerRef.current ? this.innerRef.current.offsetHeight : 0;
    return (
      <FailureScreenContainer
        isLoading={isLoading as boolean}
        height={containerHeight}
        ref={this.innerRef}
        className="failure-screen__container"
      >
        {isLoading ? (
          <Spinner isLoading={isLoading} />
        ) : (
          <FailureScreenWrapper>
            <FailureScreenTitle className="failure-screen__title">
              <FormattedMessage id={title} />
            </FailureScreenTitle>
            <FailureScreenIcon className="failure-screen__icon">
              <img src={icon} alt="icon" />
            </FailureScreenIcon>
            <FailureScreenMessage1 className="failure-screen__message1">
              <FormattedMessage id={message1} />
            </FailureScreenMessage1>
            <FailureScreenMessage2 className="failure-screen__message2">
              <FormattedMessage id={message2} />
            </FailureScreenMessage2>
            <FailureScreenButtonWrapper isRecoveryPaymentEnabled={recoveryEnabled}>
              <RecoveryPaymentButton
                className="failure-screen__recovery-payment-button"
                paymentId={paymentId}
                isRecoveryEnabled={recoveryEnabled}
                message="recoveryPayment"
                onClick={this.setLoading}
                onError={this.handleError}
              />
              <FailureScreenBackToShopButton
                isRecoveryPaymentEnabled={recoveryEnabled}
                onClick={this.handleClick}
                className="failure-screen__back-to-shop-button"
                id="backToShop"
              >
                <FormattedMessage id={buttonText} />
              </FailureScreenBackToShopButton>
            </FailureScreenButtonWrapper>
          </FailureScreenWrapper>
        )}
      </FailureScreenContainer>
    );
  }
}

export default withProgressBar(PROGRESS.PAYMENT_FAILURE)(FailureScreen);
